<template>
  <div>
    <v-row class="pt-5" no-gutters>
      <v-col>
        <TextField
          v-model="session.name"
          subtitle="Nom de la Session"
          :read-only="true"
        />
      </v-col>
    </v-row>
    <v-row class="pt-5" no-gutters>
      <TextArea
        v-model="observation"
        subtitle="Observation"
        icon="mdi-message-text"
      />
    </v-row>
    <v-row no-gutters>
      <v-spacer />
      <v-btn v-if="canUserPerformAction" color="third" class="mr-4 white--text" @click="addComent">
        Commenter
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import { inject, ref, computed } from '@vue/composition-api';
import TextArea from '@/components/common/Form/TextArea.vue';
import TextField from '@/components/common/Form/TextField.vue';
import { sendNotification } from '@/helpers/utils';

import store from '@/store';

export default {
  components: { TextArea, TextField },
  setup () {
    const observation = ref(null);

    const session = inject('selectedSession');
    const updateSession = inject('updateSession');

    const addComent = () => {
      session.value.observation = observation.value;
      updateSession();
      sendNotification('success', 'Session mise à jour avec succès');
    };

    const canUserPerformAction = computed(() => store.getters.canUserPerformAction);

    return { observation, session, addComent, canUserPerformAction };
  }
};
</script>
